import { SEVERITY_LABELS } from '@momentum/types';

const SEVERITY_DOT_COLOR: Record<number, string> = {
  [SEVERITY_LABELS.Low]: 'bg-green-600',
  [SEVERITY_LABELS.Medium]: 'bg-amber-600',
  [SEVERITY_LABELS.High]: 'bg-orange-600',
  [SEVERITY_LABELS.Critical]: 'bg-red-600',
};

const DEFAULT_COLOR = 'bg-amber-600';

export function useSeverityDotColor(): (severity: number) => string {
  return (severity: number) => SEVERITY_DOT_COLOR[severity] ?? DEFAULT_COLOR;
}
